module.exports = __webpack_public_path__ + "media/src/fonts/fontawesome-webfont-f691f37e57f04c152e2315ab7dbad881.woff";